let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9XTp5")).then(() => parcelRequire('dEGTY'));